module.exports = __webpack_public_path__ + "static/media/bannerCarPromo.3d85662e.jpg";